import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import SettingsV2 from "Administrator/routes/Settings/routes/SettingsV2";

export default store => {
  return {
    path: "other-module-settings",
    component: withAsyncRouteLoading(() =>
      import(
        /* webpackChunkName: "other-module-settings-tab" */ "AppComponents/AdminNavigation/components/SchoolTabLayout"
      ).then(module => module.default)
    ),
    childRoutes: [SettingsV2(store)],
  };
};
